import { styled } from "goober";

export const SettingsCard = styled("div")`
  background: var(--surface-secondary);
  border: 0.5px solid var(--border-alpha);
  border-radius: 12px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-sizing: border-box;
  min-width: 0;
`;

export const SettingsHeading = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 0 8px;
`;

export const SettingsRow = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;
